module.exports = __webpack_public_path__ + "img/bluesmallarrow.238c0cca.svg";